__turbopack_context__.v({
  "Separator": "TeamsList-module-scss-module__LF-wWa__Separator",
  "connectButton": "TeamsList-module-scss-module__LF-wWa__connectButton",
  "details": "TeamsList-module-scss-module__LF-wWa__details",
  "editBtn": "TeamsList-module-scss-module__LF-wWa__editBtn",
  "emptyData": "TeamsList-module-scss-module__LF-wWa__emptyData",
  "expItem": "TeamsList-module-scss-module__LF-wWa__expItem",
  "header": "TeamsList-module-scss-module__LF-wWa__header",
  "label": "TeamsList-module-scss-module__LF-wWa__label",
  "list": "TeamsList-module-scss-module__LF-wWa__list",
  "logo": "TeamsList-module-scss-module__LF-wWa__logo",
  "primaryLabel": "TeamsList-module-scss-module__LF-wWa__primaryLabel",
  "primaryTeamBadge": "TeamsList-module-scss-module__LF-wWa__primaryTeamBadge",
  "root": "TeamsList-module-scss-module__LF-wWa__root",
  "row": "TeamsList-module-scss-module__LF-wWa__row",
  "secondaryLabel": "TeamsList-module-scss-module__LF-wWa__secondaryLabel",
  "tags": "TeamsList-module-scss-module__LF-wWa__tags",
  "title": "TeamsList-module-scss-module__LF-wWa__title",
});
